import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["title", "regions", "onClick", "colorMode"];

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Heading, Link } from "../";
import styled from '@emotion/styled-base';
import { themeGet } from 'styled-system';

var getColor = function getColor(props) {
  return (props === null || props === void 0 ? void 0 : props.colorMode) === 'light' ? 'colors.white' : 'colors.greys.charcoal';
};

var StyledLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (props) {
  return themeGet(getColor(props));
});

var RegionLinks = function RegionLinks(_ref) {
  var title = _ref.title,
      regions = _ref.regions,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$colorMode = _ref.colorMode,
      colorMode = _ref$colorMode === void 0 ? 'light' : _ref$colorMode,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, {
    mb: 8,
    flexDirection: "column",
    width: ['50%', '25%']
  }, /*#__PURE__*/React.createElement(Heading.h3, _extends({
    mb: 4,
    fontSize: "base",
    color: colorMode === 'light' ? 'white' : 'greys.charcoal',
    "data-testid": title ? 'region-links-header' : undefined,
    "aria-hidden": !title
  }, rest), title !== null && title !== void 0 ? title : /*#__PURE__*/React.createElement("span", null, "\u200B")), regions.map(function (region, index) {
    return /*#__PURE__*/React.createElement(StyledLink, _extends({
      key: "footer-link-".concat(index),
      onClick: function onClick() {
        return _onClick(region);
      },
      lineHeight: "1.5",
      fontSize: "sm",
      pr: 4,
      color: colorMode === 'light' ? 'white' : 'greys.charcoal',
      colorMode: colorMode
    }, region), region.name);
  }));
};

RegionLinks.propTypes = {
  title: PropTypes.string,
  regions: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  onClick: PropTypes.func,
  colorMode: PropTypes.oneOf(['light', 'dark'])
};
export default RegionLinks;